module.exports = __webpack_public_path__ + "img/spotify_logo.8757b6b4.png";